

import './css/main.scss'
// import './blocks/ticker-block/script.js'

import Alpine from 'alpinejs'
Alpine.start()

